import React, { useEffect, useState } from 'react';
import Input from '../../ui/input';
import Textarea from '../../ui/textarea';
import { validateSite } from '../../../model/SiteModel';
import { siteDrawingUpload, siteUpdate } from '../../../redux/api/siteAPI';
import Button from '../../ui/button';
import MapboxMap from '../../map/MapboxMap';
import { getCoordinatesFromAddress } from '../../../utils/geocoding';
import { useDispatch, useSelector } from 'react-redux';
import { setUserSite } from '../../../redux/actions/authActions';
import { resolveDrawingUrl } from '../../../utils/urlHelper';
import { useTranslation } from 'react-i18next';

const localSite = () => {
    const c = JSON.parse(localStorage.getItem('site'));
    return c ? { value: c.Site_ID, label: c.Name } : null;
}

const EditSiteModal = ({ data, isOpen, onClose }) => {
    const {t} = useTranslation('Sites');
    const [formData, setFormData] = useState(data);
    const [formErrors, setFormErrors] = useState({});
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const [loadingText, setLoadingText] = useState("");
    const [showMap, setShowMap] = useState(!!data.Lat && !!data.Lng); // Initially show map if Lat and Lng are present
    const [defaultSite, setDefaultSite] = useState(null);
    const [drawingFile, setDrawingFile] = useState(null);
    const [drawingPreview, setDrawingPreview] = useState(null);
    const dispatch = useDispatch();

    const userSite = useSelector(state => state.auth.site || null);

    useEffect(() => {
        const site = localSite() || userSite || null;
        if (site?.value) {
            console.log('ssssssssssssssssssssssss', site)
            setDefaultSite(site);
        }
    }, [userSite]);

    useEffect(() => {
        setFormData(data);
        setFormErrors({});
        setShowMap(!!data.Lat && !!data.Lng); // Update showMap based on data props
        setDrawingFile(null);
        setDrawingPreview(null);
    }, [data]);

    const closeModal = (refresh=false) => {
        setFormData({
            Name: '',
            Description: '',
            location: '',
            Work_hours: null,
            nbr_workers:null,
            Lat: "",
            Lng: ""
        });
        setShowMap(false); // Reset showMap state when closing modal
        setDrawingFile(null);
        setDrawingPreview(null);
        onClose(refresh);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        if (formErrors[name]) {
            setFormErrors(prevErrors => ({
                ...prevErrors,
                [name]: ''
            }));
        }
    };

    const handleLocationSelect = (location) => {
        setFormData(prevData => ({
            ...prevData,
            Lat: location.lat,
            Lng: location.lng
        }));
    };

    const handleDrawingChange = (e) => {
        const file = e.target.files?.[0] || null;
        setDrawingFile(file);
        if (drawingPreview) URL.revokeObjectURL(drawingPreview);
        if (file && file.type.startsWith("image/")) {
            setDrawingPreview(URL.createObjectURL(file));
        } else {
            setDrawingPreview(null);
        }
    };

    const handleGeocodeAddress = async () => {
        try {
            const { lat, lng } = await getCoordinatesFromAddress(formData.location);
            setFormData(prevData => ({
                ...prevData,
                Lat: lat,
                Lng: lng
            }));
            setShowMap(true); // Show map after successful geocoding
        } catch (error) {
            console.error('Error geocoding address:', error);
            setFormErrors(prevState => ({
                ...prevState,
                location: 'Unable to determine coordinates from the address'
            }));
        }
    };

    const validateForm = async () => {
        try {
            await validateSite(formData);
            return true; // Form is valid
        } catch (error) {
            const validationErrors = {};
            error.inner.forEach(err => {
                validationErrors[err.path] = err.message;
            });
            setFormErrors(validationErrors);
            return false; // Form is invalid
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = await validateForm();
        if (isValid) {
            let timeout;
            try {
                setLoading(true);
                setLoadingText("Updating Site...");
                timeout = setTimeout(() => {
                    setLoadingText("This is taking longer than usual. Please wait.");
                }, 5000);
                const result = await siteUpdate(formData);
                if (result.data) {
                    if (drawingFile) {
                        const uploadResult = await siteDrawingUpload(formData.Site_ID, drawingFile);
                        if (uploadResult.error) {
                            setError(uploadResult.error);
                            setLoading(false);
                            clearTimeout(timeout);
                            return;
                        }
                    }
                    console.log('deff', (defaultSite?.value == formData.Site_ID))
                    console.log('defaultSite?.Site_ID', defaultSite?.value)
                    console.log('formData.Site_ID', formData.Site_ID)


                    if (defaultSite?.value === formData.Site_ID) {
                        setDefaultSite({ value: formData.Site_ID, label: formData.Name });
                        localStorage.setItem('site', JSON.stringify({ Site_ID: formData.Site_ID, Name: formData.Name }));
                        dispatch(setUserSite({ value: formData.Site_ID, label: formData.Name }));
                    }
                    closeModal(true);
                } else {
                    setError(result.error);
                }
                setLoading(false);
                clearTimeout(timeout);
            } catch (error) {
                console.error("Error updating site:", error);
                setError("An unexpected error occurred while updating the site.");
                setLoading(false);
                clearTimeout(timeout);
            }
        }
    };
    const toggleMap = () => {
        setShowMap(!showMap); // Toggle showMap state
    };
    return (
        <form data-testid="site-edit-form" onSubmit={handleSubmit}>
            <div className="grid gap-7 max-lg:grid-cols-1 grid-cols-2 w-auto m-2 bg-white max-md:p-3 p-8 rounded-3xl shadow-lg">
                <p className="flex justify-center col-span-full text-xl text-[#4C4C66] font-bold mb-4">{t('edit_site_details')}</p>
                
                {/* Left Column */}
                <div className="flex flex-col gap-4">
                    <Input
                        required
                        label={t('name')}
                        name="Name"
                        value={formData.Name}
                        onChange={handleChange}
                        placeholder={t('enter_site_name')}
                        error={formErrors.Name}
                    />
                    <div className="grid grid-cols-2 gap-4">
                        <Input
                            required
                            label={t('work_hours')}
                            name="Work_hours"
                            value={formData.Work_hours}
                            onChange={handleChange}
                            placeholder={t('enter_work_hours_in_a_day_per_worker')}
                            error={formErrors.Work_hours}
                        />
                        <Input
                            required
                            label={t('number_of_workers')}
                            name="nbr_workers"
                            value={formData.nbr_workers}
                            onChange={handleChange}
                            placeholder={t('enter_number_of_workers')}
                            error={formErrors.nbr_workers}
                        />
                    </div>
                    <Textarea
                        required
                        label={t('address')}
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        placeholder={t('enter_site_address')}
                        error={formErrors.location}
                        maxLength={200}
                        rows={2}
                    />
                    <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-end'>
                        <Button
                            disabled={!formData.location}
                            type="button"
                            onClick={handleGeocodeAddress}
                            color={"secondary"}
                        >{t('drop_a_pin')}</Button>
                        <Input
                            label={t('latitude')}
                            name="Lat"
                            type="number"
                            value={formData.Lat || ''}
                            onChange={handleChange}
                            placeholder={t('enter_latitude')}
                        />
                        <Input
                            label={t('longitude')}
                            name="Lng"
                            type="number"
                            value={formData.Lng || ''}
                            onChange={handleChange}
                            placeholder={t('enter_longitude')}
                        />
                    </div>
                </div>

                {/* Right Column */}
                <div className="flex flex-col gap-4">
                    <Textarea
                        label={t('description')}
                        name="Description"
                        value={formData.Description}
                        onChange={handleChange}
                        placeholder={t('enter_site_description')}
                        error={formErrors.Description}
                        maxLength={200}
                    />
                    <div className="flex flex-col gap-2">
                        <label className="text-sm text-[#4C4C66] pb-1 pl-2">Site drawing</label>
                        <input
                            type="file"
                            accept="image/png,image/jpeg,image/webp,application/pdf"
                            onChange={handleDrawingChange}
                            className="rounded-xl bg-[#F4F6FA] p-3 text-sm text-[#4C4C66]"
                        />
                        {drawingPreview ? (
                            <img
                                src={drawingPreview}
                                alt="Site drawing preview"
                                className="max-h-40 rounded-lg border object-contain"
                            />
                        ) : formData.Drawing_url && formData.Drawing_type === "image" ? (
                            <img
                                src={resolveDrawingUrl(formData.Drawing_url)}
                                alt="Current site drawing"
                                className="max-h-40 rounded-lg border object-contain"
                            />
                        ) : formData.Drawing_url ? (
                            <p className="text-xs text-gray-500">Current drawing: {formData.Drawing_url}</p>
                        ) : null}
                        {drawingFile && !drawingPreview && (
                            <p className="text-xs text-gray-500">{drawingFile.name}</p>
                        )}
                    </div>
                    <div className='pb-5'>
                        <p className='text-sm text-[#4C4C66] pb-1 pl-2'>{t('map')}</p>
                        <MapboxMap
                            onLocationSelect={handleLocationSelect}
                            initialLat={formData.Lat}
                            initialLng={formData.Lng}
                            initialZoom={14}
                        />
                    </div>
                </div>

                {error && (
                    <div className="col-span-full flex justify-center space-x-5">
                        <span className="my-4 ml-2 text-xs text-[#FF0000]">{t('error_updating_site')}</span>
                    </div>
                )}
                <div className='col-span-full flex justify-center mt-10 space-x-5'>
                    <Button
                        onClick={closeModal}
                        color={"cancel"}
                    >{t('cancel')}</Button>
                    <Button
                        data-testid="site-edit-submit"
                        disabled={loading}
                        type="submit"
                    >
                        {loading ? loadingText : 'Update Site'}
                    </Button>
                </div>
            </div>
        </form>
    );
};

export default EditSiteModal;
